<template>
  <div class="orders-page page">
    <div class="orders-page__title">
      <div class="container">
        <div class="orders-page--wrap">
          <button @click="$router.go(-1)" class="services__header-prev-btn">
            <icon name="arrow-left" />
          </button>
          <h1>{{ $t("services.orders.pageTitle") }}</h1>
        </div>
        <BreadCrumbs class="breadcrumbs-margin" :links="breadcrumbs" />
        <Notification
          v-if="locale === 'ru'"
          class="orders-page__notification"
          icon="warning-border--no-color"
        >
          Если Вы хотите получать закрывающие документы по дополнительным
          услугам в системе ЭДО, направьте нам приглашение: <br />
          АО «ЭКСПОЦЕНТР», ИНН 7718033809 <br />
          Идентификационный номер в системе ЭДО:
          2BM-7718033809-770301001-201411210937282283051
        </Notification>
      </div>
    </div>
    <div v-if="loading" class="page-loading">{{ $t("services.loading") }}</div>
    <div class="page-loading" v-else-if="is403Error">
      {{ $t("services.error403") }}
    </div>
    <div v-else class="container">
      <div class="orders-page__container">
        <OrdersTable
          :items="items"
          :executors="executors"
          @reload="initOrders"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OrdersTable from "../components/UI/Table/OrdersTable.vue";
import { BreadCrumbs, Notification } from "@v2/shared/ui/components";
import { mapState } from "vuex";
import { Websocket } from "@/helpers/websocket";
import { i18n } from "@v2/shared/config";

export default {
  name: "OrdersPage",
  components: { Notification, OrdersTable, BreadCrumbs },
  data: () => ({
    loading: true,
    socket: new Websocket(),
    is403Error: false
  }),
  computed: {
    ...mapState("event", ["executors"]),
    breadcrumbs() {
      return [
        {
          title_rus: "Выставка",
          title_eng: "Exhibition",
          route: { name: "participant", params: { id: this.$route.params.id } }
        }
      ];
    },
    items() {
      return this.$store.getters["services/participantOrders"];
    },
    locale() {
      return i18n.locale;
    }
  },
  methods: {
    async initOrders() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "services/getParticipantOrders",
          this.$route.params.id
        );
      } catch (e) {
        this.is403Error = e.error_data?.response?.status === 403;
      } finally {
        this.loading = false;
      }
    },
    connectedWebSocket() {
      const id = this.$route.params.id;
      this.socket.connectParticipant(id, data => {
        if (data.order) {
          this.$store.dispatch(
            "services/updateParticipantOrderStatus",
            data.order
          );
        }
      });
    },
    async loadExecutors() {
      try {
        await this.$store.dispatch("event/getExecutors", this.$route.params.id);
      } catch (e) {
        this.is403Error = e.error_data?.response?.status === 403;
      }
    }
  },
  async created() {
    await this.loadExecutors();
  },
  mounted() {
    this.initOrders();
    this.connectedWebSocket();
  },
  beforeDestroy() {
    if (this.event?.id) {
      this.socket.disconnectParticipant(this.event.id);
    }
  }
};
</script>

<style lang="scss">
.breadcrumbs-margin {
  margin-bottom: 30px;
}
.tabs {
  width: 100%;
  display: inline-flex;
  align-items: center;
  border-bottom: 2px solid var(--gray-darker);

  &__item {
    height: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--gray-dark);
    text-decoration: none;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    border-bottom: 2px solid transparent;
    position: relative;
    bottom: -2px;

    &:not(:last-child) {
      margin-right: 40px;
    }

    &--active {
      color: var(--dark);
      border-color: var(--main-dark);
    }
  }
}

.orders-page {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .container {
    margin: 0 auto;
    padding: 0 15px;
    width: 100%;
    box-sizing: border-box;
  }
  &--wrap {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  &__container {
    padding: 50px 0;
    width: 100%;
    display: inline-flex;
    align-items: flex-start;
    flex-direction: column;
    @media (max-width: 740px) {
      padding: 30px;
      margin: 0;
    }
    @media (max-width: 480px) {
      padding: 30px 0;
    }

    .tabs {
      margin-bottom: 30px;
      @media (max-width: 740px) {
        margin-bottom: 15px;
      }
    }
  }

  &__title {
    border-bottom: 1px solid var(--gray-darker);
    background: var(--white);
    width: 100%;

    .container {
      @media (max-width: 740px) {
        margin: 0;
        padding: 0 30px;
      }
    }

    h1 {
      color: var(--dark);
      font-size: 2.125rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin: 30px 0;

      @media (max-width: 740px) {
        font-size: 1.25rem;
      }
    }
  }
  &__notification {
    display: flex;
    margin-bottom: 30px;
  }
}

.responsible {
  padding: 15px;
  display: flex;
  flex-direction: column;

  &__title {
    color: var(--dark-light);
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 5px;
  }

  &__person {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    img {
      object-fit: cover;
      object-position: center;
      width: 60px;
      height: 60px;
      border-radius: 100%;
    }
  }

  &__person-data {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 10px;
  }

  &__person-name {
    color: var(--dark);
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    margin-bottom: 4px;
  }

  &__person-contacts {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--dark-light);
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    &:not(:last-child) {
      margin-bottom: 4px;
    }

    & > span:first-child {
      color: var(--dark);
      font-weight: 700;
      margin-right: 5px;
    }
  }
}

.orders-page-table {
  &__expand {
    padding: 30px !important;
    @media (max-width: 740px) {
      padding: 15px !important;
    }

    & > .table {
      margin-bottom: 15px;
    }
  }

  &__chat {
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: none;
    padding: 0;
    margin: 0;
    border: none;
    border-radius: 2px;
    position: relative;
    cursor: pointer;
    transition: background-color var(--transition, 0.2s);

    &:hover {
      background: var(--gray-2, #eaeaea);
    }

    svg {
      width: 20px;
      height: 20px;
      color: var(--main);
    }

    & > span {
      position: absolute;
      right: 10px;
      top: 10px;
      transform: translate(50%, -50%);
      width: 15px;
      height: 15px;
      border-radius: 100%;
      background: var(--main-dark);
      color: var(--white);
      font-size: 0.375rem;
      font-style: normal;
      font-weight: 500;
      line-height: 6px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__dots {
    @extend .orders-page-table__chat;
    position: relative;
  }

  &__status {
    display: flex;
    align-items: center;
    @media (max-width: 740px) {
      flex-wrap: wrap;
      justify-content: flex-end;
    }

    button {
      margin-left: 10px;
      padding: 10px 5px;
      height: 28px;
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      @media (max-width: 740px) {
        margin-left: 0;
      }
    }
  }
}
.services__header-prev-btn {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border: 1px solid var(--gray-darker, #d5dae5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color var(--transition, 0.2s);
  margin-right: 15px;
  color: var(--gray-dark, #a3a8b3);
  background: none;
  cursor: pointer;

  &:hover {
    background: var(--main-bg, #f0f5f9);
  }

  .svg-icon {
    max-width: 100%;
    max-height: 100%;
    width: 20px;
    height: 20px;
  }
}
</style>
